import React from 'react';
import { createPortal } from 'react-dom';
import styles from './day-calendar.module.scss';
import { CalendarDayType } from 'shared/api/booking/interfaces/calendar-day.type';
import { CircleImage } from 'shared/ui';
import { EmployeeWorkDayPopup } from 'shared/ui/employee-work-day-popup/employee-work-day-popup';

interface EmployeeListProps {
  calendarData: CalendarDayType | undefined;
  selectedEmployeeId: string | null;
  onToggleEmployeePopup: (employeeId: string) => void;
  employeeListRef: React.RefObject<HTMLDivElement>;
  employeeCardRefs: React.MutableRefObject<Map<string, HTMLDivElement | null>>;
  date: Date;
  onUpdate: () => void;
  onCloseEmployeePopup: () => void;
}

export const EmployeeList: React.FC<EmployeeListProps> = ({
  calendarData,
  selectedEmployeeId,
  onToggleEmployeePopup,
  employeeListRef,
  employeeCardRefs,
  date,
  onUpdate,
  onCloseEmployeePopup,
}) => {
  return (
    <div className={styles.employee__list} ref={employeeListRef}>
      {calendarData?.map((employee) => (
        <div
          key={employee.employee.id}
          ref={(el) => employeeCardRefs.current.set(employee.employee.id, el)}
          className={styles.list__employee_card}
          onMouseDown={() => onToggleEmployeePopup(employee.employee.id)}
        >
          <div className={styles.employee_card__img}>
            <CircleImage imgSize={35} imgSrc={employee.employee.imgUrl} />
          </div>
          <div className={styles.employee_card__fio}>
            {employee.employee.fio.split(' ')[1]}
          </div>
          {selectedEmployeeId === employee.employee.id &&
            createPortal(
              <EmployeeWorkDayPopup
                employee={employee}
                date={date}
                onClose={onCloseEmployeePopup}
                onUpdate={onUpdate}
                triggerCardRef={employeeCardRefs.current.get(
                  employee.employee.id
                )}
              />,
              document.body
            )}
        </div>
      ))}
    </div>
  );
};
